import type { AppEnv } from "../config/env";

export type RuntimeContext = {
  environment: AppEnv["VITE_APP_ENV"];
  sessionId: string;
  correlationId: string;
  userId?: string;
  route?: string;
  productId?: string;
  projectId?: string;
  departmentId?: string;
  agentId?: string;
};

const DATABASE_UUID_PREFIXES = new Set([
  "conversation",
  "message",
  "goal",
  "execution_plan",
  "decision",
  "reflection",
  "approval",
  "approval_event",
  "tool_intent",
  "timeline",
  "execution",
  "reasoning_summary",
]);

export function createId(prefix: string): string {
  if (globalThis.crypto?.randomUUID) {
    const uuid = globalThis.crypto.randomUUID();
    return DATABASE_UUID_PREFIXES.has(prefix) ? uuid : `${prefix}_${uuid}`;
  }

  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export function createStartupRuntimeContext(
  environment: RuntimeContext["environment"],
): RuntimeContext {
  return {
    environment,
    sessionId: createId("session"),
    correlationId: createId("startup"),
  };
}

export function withNewCorrelation(
  context: RuntimeContext,
  prefix = "corr",
): RuntimeContext {
  return {
    ...context,
    correlationId: createId(prefix),
  };
}
